import { Box, Flex, Text } from '@chakra-ui/react';
import { ReelIcon } from 'ui-components';
import { FEATURE_FLAGS } from '~/constants';
import { useFeature } from '~/hooks/useFeatureFlag/useFeature';
import customTheme from '~/styles/theme';

import { useDropActions } from './useDropActions';

export const SideBarVideo = () => {
  const { isEnabled } = useFeature(FEATURE_FLAGS.foamMediaKitsVideo);
  const triggerActions = useDropActions();

  const handleClick = () => {
    triggerActions('TalentVideo');
  };

  if (!isEnabled) return null;

  return (
    <Box
      backgroundColor="neutral.100"
      border={`1px solid ${customTheme.colors.primary['100']}`}
      padding={4}
      borderRadius={8}
      cursor="pointer"
      onClick={handleClick}
      _hover={{ backgroundColor: 'neutral.200' }}
      transition="all 0.2s ease-in-out"
      track-id="add-video-to-media-kit"
      as="button"
    >
      <Flex gap={1} align="center" justify="center">
        <ReelIcon boxSize="14px" color="primary.700" />
        <Text fontSize="md" fontWeight="500" color="primary.700">
          Video
        </Text>
      </Flex>
    </Box>
  );
};
